import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const pendingInvoicesGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const hasUserId = route.queryParamMap.has('id');

  if (hasUserId) {
    return true;
  }

  void router.navigate(['/cotizador']);
  return false;
};
